import type { ComponentChildren } from 'preact';

export type StatCardSize = 'sm' | 'md' | 'wide' | 'lg' | 'feature' | 'tall';

interface StatCardProps {
  icon: ComponentChildren;
  accent: 'lime' | 'cyan' | 'purple' | 'amber' | 'red' | 'teal' | 'blue' | 'pink';
  value: string;
  label: string;
  sub?: string;
  valueClass?: string;
  size?: StatCardSize;
  featured?: boolean;
  danger?: boolean;
  trailing?: ComponentChildren;
}

export function StatCard({
  icon,
  accent,
  value,
  label,
  sub,
  valueClass,
  size = 'sm',
  featured,
  danger,
  trailing,
}: StatCardProps) {
  const sizeClass = size === 'sm' ? '' : ` size-${size}`;
  const featuredClass = featured ? ' featured' : '';
  const dangerClass = danger ? ' danger' : '';

  return (
    <div class={`stat-card${sizeClass}${featuredClass}${dangerClass}`}>
      <div class="stat-head">
        <div class={`stat-icon accent-${accent}`}>{icon}</div>
        {trailing}
      </div>
      <div class="stat-body">
        <div class={`stat-value${valueClass ? ` ${valueClass}` : ''}`}>{value}</div>
        <div class="stat-label">{label}</div>
        {sub && <div class="stat-sub">{sub}</div>}
      </div>
    </div>
  );
}
